export default __webpack_public_path__ + "static/logo_default-410aabb84f06aee8b8013f2c200fb9a2.png";